import { createFileRoute } from '@tanstack/react-router';

import { UserDetailsPage } from '@/features/users/UserDetailsPage';

function UserDetailsRoute() {
  const { userId } = Route.useParams();
  return <UserDetailsPage userId={userId} />;
}

export const Route = createFileRoute('/admin/_app/users/$userId/')({
  component: UserDetailsRoute,
});
